"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadingInvoicing = exports.InvoicingStatuses = void 0;
var InvoicingStatuses = {
  notConfigured: 'Not Configured',
  notInvoiceable: 'Not Invoiceable',
  readyForInvoice: 'Ready for Invoice',
  invoiced: 'Invoiced',
  hidden: "Hidden",
  error: "Error"
};
exports.InvoicingStatuses = InvoicingStatuses;
var loadingInvoicing = {
  NOT_LOADING: 'notLoading',
  LOADING: 'loading',
  AVAILABLE: 'available',
  NOT_AVAILABLE: 'notAvailable'
};
exports.loadingInvoicing = loadingInvoicing;